import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconTriangleWarningSvg } from './IconTriangleWarningSvg';

export const IconTriangleWarning: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconTriangleWarningSvg} {...iconProps} />;
};
